import * as Yup from 'yup';

export const CreatePoll = Yup.object().shape({
  title: Yup.string().required('question is required'),
  options: Yup.array()
    .of(Yup.string().required('option is required'))
    .min(1, 'poll options are required'),
  time_number: Yup.string().required('duration is required'),
});
